import { FC } from "react";
import { Select as MuiSelect, SelectProps } from "@mui/material";

type Props = {
  children?: JSX.Element | JSX.Element[];
} & SelectProps;

const Select: FC<Props> = (props) => {
  let sx = { ...props.sx };
  if (typeof props.sx === "function") {
    sx = props.sx;
  }

  return (
    <MuiSelect {...props} sx={sx}>
      {props.children}
    </MuiSelect>
  );
};

export default Select;
